import RecentCharts from 'dashboards/RecentPatients/RecentPatients';



export default RecentCharts;
